var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-title"},[_vm._v("Youth roadmap for associations and clubs for UNESCO 2025 –2030")]),_c('iframe',{staticClass:"pdf-iframe",staticStyle:{"display":"block"},attrs:{"src":"/Youth roadmap for associations and clubs for UNESCO 2025 –2030.pdf","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }